import BadgesService from './BadgesService'

export default BadgesService
